<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            
            <CInput class="mt-3" v-model="form.firstname"  label="Firstname"   />
            <CInput v-model="form.lastname" label="Lastname"   />
            <CInput v-model="form.dob" type="date" label="Date of Birth"   />
            <label> Gender </label>
            <b-form-group  >
              <b-form-radio v-model="form.sex"  name="some-radios" value="male">Male</b-form-radio>
              <b-form-radio v-model="form.sex" name="some-radios" value="female">Female</b-form-radio>
            </b-form-group>
            <CInput v-model="form.email"  label="Email"   />
            <CInput v-model="form.phone" label=" Phone"   />
            <CInput v-model="form.mobile_phone" label="Mobile Phone"   />
            <CInput v-model="form.address1" label="Address 1"   />
            <CInput v-model="form.address1" label="Address 2"   />
            <CInput v-model="form.city" label="City"   />
            <CInput v-model="form.state" label="State"   />
            <CInput v-model="form.country" label="Country"   />
            <CInput v-model="form.zipcode" label="Zipcode"   />

         
            
          </CCol> 
          </CRow>
       
         <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Update</CButton>
        
        </template>
    </CModal>
  </form>
</template>
<script>
import EventBus from '@/eventBus';

import people from '@/services/people'

import moment from 'moment'

export default {
name: 'peoplemodal',
  data () {
   return {
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        id: '',
        uuid:'',
        firstname: '',
        lastname:'',
        email:'',
        phone :'',
        mobile_phone:'',
        address1:'',
        address2:'',
        city:'',
        state:'',
        country:'',
        zipcode:'',
        dob:'',
        sex:'',

      }
    }
  },

  mounted (){
     
   },
  
  created () {
    var self = this;
    
    EventBus.$on('OPEN_MODAL_EDIT_PEOPLE', (params) => {
      if(params.data){
        people.getPeoplebyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.uuid = params.data;
          self.form.firstname = res.data.firstname;
          self.form.lastname = res.data.lastname;
          self.form.email = res.data.email;
          self.form.phone = res.data.phone;
          self.form.mobile_phone = res.data.mobile_phone;
          self.form.address1 = res.data.address1;
          self.form.address2 = res.data.address2;
          self.form.city = res.data.city;
          self.form.state = res.data.state;
          self.form.country = res.data.country;
          self.form.zipcode = res.data.zipcode;
          self.form.dob = res.data.dob;
          self.form.sex = res.data.sex;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.uuid = "";
        self.form.firstname = "";
        self.form.lastname = "";
        self.form.email = "";
        self.form.phone = "";
        self.form.mobile_phone = "";
        self.form.address1 = "";
        self.form.address2 = "";
        self.form.city = "";
        self.form.state = "";
        self.form.country = "";
        self.form.zipcode = "";
        self.form.dob = "";
        self.form.sex = "";
      }
    });
    this.form.uuid = this.$route.query.Pud
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
   update(id){
      this.show = false;
       if( this.form.dob != null ){this.form.dob  = moment(this.form.dob).format ('DD/MM/YYYY')}
      people.updatePeople(id,this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        this.showModal= false
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })

    },  
  
   
  }
}
</script>

<style>

</style>